// extracted by mini-css-extract-plugin
export default {"backButton":"YearbookByYear_backButton__G6NSd"};